// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__AiX4U","logo":"style_logo__1ZwLZ"};